const state = {
    annee_reference: null,

    effectif_smic: 0,
    effectif_smic_plus: 0,
    effectif_oetam: 0,
    effectif_cadres: 0,
    effectif_etrangers: 0,

    taux_at: 0.02,

    masse_salariale_brute_smic: 0,
    masse_salariale_brute_smic_plus: 0,
    masse_salariale_brute_oetam: 0,
    masse_salariale_brute_cadres: 0,

    profitable: true,
    chiffre_affaires: 0,
    resultat_net_initial: 0,

    delegation: false,
    simulation_results: {}
}

const mutations = {
    SET_ANNEE_REFERENCE(state, value) {
        state.annee_reference = value
    },

    SET_EFFECTIFS(state, value) {
        state.effectif_smic = parseFloat(value.smic)
        state.effectif_smic_plus = parseFloat(value.smic_plus)
        state.effectif_oetam = parseFloat(value.oetam)
        state.effectif_cadres = parseFloat(value.cadres)
        state.effectif_etrangers = parseFloat(value.etrangers)
    },

    SET_TAUX_AT(state, value) {
        state.taux_at = parseFloat(value) / 100
    },

    SET_MASSE_SALARIALE(state, value) {
        state.masse_salariale_brute_smic = parseFloat(value.smic)
        state.masse_salariale_brute_smic_plus = parseFloat(value.smic_plus)
        state.masse_salariale_brute_oetam = parseFloat(value.oetam)
        state.masse_salariale_brute_cadres = parseFloat(value.cadres)
    },

    SET_RESULTAT(state, value) {
        state.profitable = value.profitable
        state.chiffre_affaires = parseFloat(value.chiffre_affaires)
        state.resultat_net_initial = value.profitable
            ? parseFloat(value.result)
            : -parseFloat(value.result)
    },

    SET_DELEGATION(state, value) {
        this.delegation = value
    },

    SET_SIMULATION_RESULT(state, value) {
        state.simulation_results = value;
    }
}

export default {
    namespaced: true,
    state,
    mutations
}
